import React, { useEffect, useRef, useState } from "react";
import { Alert, Button, Form, Input } from "@intech/web-ui";
import { useHistory } from "react-router-dom";

import { BaseAuth } from "../Base";
import { LoginEntidade } from "@entidades";
import { FaEyeSlash, FaEye, FaArrowRight } from "react-icons/fa";
import { DadosPessoaisService, UsuarioService } from "@services";
import { LoadingComponent } from "@components";
import { Session } from "@intech/react-service";

export const TrocarSenhaPrimeiroAcesso: React.FC = () => {
  const history = useHistory();

  const [senhaVisivel, setSenhaVisivel] = useState(false);
  const [senhaNovaVisivel, setSenhaNovaVisivel] = useState(false);

  const [nome, setNome] = useState("");
  const [senhaNova, setSenhaNova] = useState("");
  const [senhaNovaConfirma, setSenhaNovaConfirma] = useState("");

  const [Erros, setErros] = useState(null);
  const [Loading, setLoading] = useState<boolean>(true);

  const form = useRef<Form>(null);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const dados = await DadosPessoaisService.Buscar();
        setNome(dados.NO_PESSOA);
      } catch (e) {
        const err: any = e;

        if (err.message.indexOf("401") > -1) {
          await Session.clear();
          window.alert("Houve um erro de autenticação, favor realizar o login novamente.");
          history.push("/login");
          return;
        }

        setErros(err.response ? err.response.data : err);
      }
      finally {
        setLoading(false);
      }
    })();
  }, [history]);

  async function trocarSenha() {
    try {
      setErros(null);

      if (senhaNova.length < 8) {
        setErros(
          "A senha deve conter pelo menos 8 caracteres, um número (0-9), uma letra minúscula e maiúscula (a-z, A-Z) e um caracter especial."
        );
        return;
      }

      // Valida se os campos de nova senha e confirmação são iguais.
      if (senhaNova !== senhaNovaConfirma) {
        setErros("As senhas não coincidem.");
        return;
      }
      const erros = await form?.current?.validate();

      if (erros) {
        setErros(erros);
        return;
      }

      const data = new LoginEntidade();
      data.SenhaNova = senhaNova;
      data.SenhaNovaConfirma = senhaNovaConfirma;

      await UsuarioService.AlterarSenhaPrimeiroAcesso(data);
      window.alert("Senha alterada com sucesso!");
      history.push("/");
    } catch (e) {
      const err: any = e;
      setErros((err.response ? err.response.data : err) || "Houve um erro ao carregar os seu primeiro acesso, tente novamente mais tarde. Caso o problema persista entre em contato com a Fundação.");
    }
  }

  return (
    <BaseAuth tamanho={550}>
      {Loading && <LoadingComponent />}

      {!Loading && Erros && <Alert type={"danger"}>{Erros}</Alert>}

      {!Loading && !Erros && <>
        <div className="mt-5">
          Olá, <b>{nome}</b>,<br />
          <br />
          Seja bem-vindo!
          <br />
          <br />
          Esse é o seu primeiro acesso ao novo Portal da Regius! Como você
          recebeu uma nova senha gerada automaticamente, ou acessou utilizando a
          sua senha do portal antigo, será necessário que você crie uma nova
          senha.
          <br />
          <br />
          <Alert type={"info"}>
            "A senha deve conter pelo menos 8 caracteres, um número (0-9), uma
            letra minúscula (a-z), uma letra maiúscula (A-Z) e um caráter especial
            (@, #, $, %, *, por exemplo)."
          </Alert>
          <Form ref={form}>
            <Input
              title="Nova Senha"
              value={senhaNova}
              onChange={setSenhaNova}
              labelSize={4}
              required
              group
              type={senhaVisivel ? "text" : "password"}
              icon={senhaVisivel ? <FaEyeSlash /> : <FaEye />}
              buttonLeft={false}
              onButtonClick={() => setSenhaVisivel((old) => !old)}
            />

            <Input
              title="Confirme nova senha"
              value={senhaNovaConfirma}
              onChange={setSenhaNovaConfirma}
              labelSize={4}
              required
              group
              type={senhaNovaVisivel ? "text" : "password"}
              icon={senhaNovaVisivel ? <FaEyeSlash /> : <FaEye />}
              buttonLeft={false}
              onButtonClick={() => setSenhaNovaVisivel((old) => !old)}
            />
          </Form>
          <Alert type={"danger"}>{Erros}</Alert>
          <Button
            title={"Continuar"}
            onClick={trocarSenha}
            type={"primary"}
            icon={<FaArrowRight />}
            block
          />
        </div>
      </>}
    </BaseAuth>
  );
};
